/* OCTA — athlete page behaviours. No dependencies, safe to load anywhere. */
(function () {
  'use strict';

  /* Click-to-copy discount codes ----------------------------------------- */
  function bindCopy(root) {
    root.querySelectorAll('[data-athlete-copy]:not([data-bound])').forEach(function (el) {
      el.setAttribute('data-bound', '');
      el.addEventListener('click', function () {
        var code = el.getAttribute('data-athlete-copy');

        var done = function () {
          el.setAttribute('data-copied', 'true');
          setTimeout(function () { el.removeAttribute('data-copied'); }, 1800);
        };

        /* Older browsers, and any context where the async clipboard is refused. */
        var legacyCopy = function () {
          var ta = document.createElement('textarea');
          var copied = false;
          ta.value = code;
          ta.setAttribute('readonly', '');
          ta.style.cssText = 'position:absolute;left:-9999px';
          document.body.appendChild(ta);
          ta.select();
          try { copied = document.execCommand('copy'); } catch (e) { copied = false; }
          document.body.removeChild(ta);
          return copied;
        };

        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(code).then(done).catch(function () {
            if (legacyCopy()) done();
          });
          return;
        }

        if (legacyCopy()) done();
      });
    });
  }

  /* Gallery videos: click the poster to play in place --------------------- */
  function bindPlay(root) {
    root.querySelectorAll('[data-athlete-play]:not([data-bound])').forEach(function (btn) {
      btn.setAttribute('data-bound', '');
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.athlete-gallery__item');
        if (!wrap) return;

        var video = wrap.querySelector('video');
        if (video) {
          video.setAttribute('controls', '');
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
          btn.hidden = true;
          return;
        }

        var embed = btn.getAttribute('data-athlete-embed');
        if (!embed) return;

        var iframe = document.createElement('iframe');
        iframe.src = embed;
        iframe.title = btn.getAttribute('aria-label') || 'Video';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.loading = 'lazy';
        wrap.appendChild(iframe);
        btn.hidden = true;
      });
    });
  }

  function init(root) {
    bindCopy(root || document);
    bindPlay(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Theme editor re-renders sections without a page load. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
